<template>
    <router-link
        v-if="is_can_use"
        :to="{name: $store.state.initialize_statuses.sidebar ? item.name:null}"
    >
        <i v-if="item.icon" :class="item.icon+' icon'"></i>
        <span> {{ $t('ui.links.menu.'+item.name) }} </span>
    </router-link>

    <div v-else class="cannot_use" :data-tooltip="$t('ui.general.cannot_use')" data-position="right center">
        <i v-if="item.icon" :class="item.icon+' icon'"></i>
        <span> {{ $t('ui.links.menu.'+item.name) }} </span>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            is_can_use: this.check_can_use_current_menu(),
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        check_can_use_current_menu() {
            try {
                if (this.item) {
                    var result = _.findLast(this.$store.state.provider.theme_menu, (menu_name) => {
                        return this.item.name == menu_name
                    })
                    throw (result) ? true : false
                }
                throw false

            } catch (result_boolean) {
                return result_boolean
            }

            return false
        },
    },
}
</script>
